import { render, staticRenderFns } from "./BoundaryEvent.vue?vue&type=template&id=492000d7"
import script from "./BoundaryEvent.vue?vue&type=script&lang=js"
export * from "./BoundaryEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports